import WatsonComponentsGlobal from "@/components/watson/WatsonComponentsGlobal";
import "./watson-components-compatibility.scss";

export default {
  install: WatsonComponentsGlobal.install,
};
